import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  SimpleChanges,
  ViewContainerRef,
} from '@angular/core';
import { MessagePopoverComponent } from 'src/app/layout/components/message-popover/message-popover.component';

@Directive({
  selector: '[textPopover]',
  standalone: true,
})
export class TextPopoverDirective {
  @Input() placement: string = 'top';
  @Input() copyValue: string;
  @Input() title: string;
  @Input() fullText: string;
  @Input() parentSelector: string;
  @Input() hidePopover: boolean = false;
  @Input() selectorType: 'tag' | 'id' = 'tag';

  rightPopover: boolean = false;
  popover: HTMLElement;
  componentRef;
  offset = 10;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private viewContainerRef: ViewContainerRef
  ) {}

  @HostListener('click') onMouseEnter() {
    if (!this.fullText) return;
    this.show();
    this.setPosition();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.fullText)
      this.renderer.addClass(this.el.nativeElement, 'after-icon');

    if (changes['hidePopover']) if (this.hidePopover) this.remove();
  }

  show() {
    this.create();
    this.setPosition();
  }

  create() {
    if (!this.componentRef) {
      this.componentRef = this.viewContainerRef.createComponent(
        MessagePopoverComponent
      );
      this.popover = this.componentRef.location.nativeElement;
    }

    this.componentRef.instance.fullText = this?.fullText;
    this.componentRef.instance.title = this?.title;

    this.checkPopoverPosition();

    this.componentRef.instance.isVisible =
      !this.componentRef.instance.isVisible;
    let parent: any;

    if (this.selectorType == 'id')
      parent = document.querySelector('#' + this.parentSelector);
    else parent = document.querySelector(this.parentSelector);

    if (parent) {
      this.renderer.appendChild(
        parent,
        this.componentRef.location.nativeElement
      );
      this.renderer.addClass(this.popover, 'msg-popover');
      this.renderer.addClass(this.popover, `msg-popover-${this.placement}`);
    }
  }

  setPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const tooltipPos = this.popover.getBoundingClientRect();
    const scrollPos =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    let top, left;

    if (this.placement === 'top') {
      top = hostPos.top - tooltipPos.height - this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === 'bottom') {
      top = hostPos.bottom + this.offset;
      left = hostPos.left + (hostPos.width - tooltipPos.width) / 2;
    }

    if (this.placement === 'left') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.left - tooltipPos.width - this.offset;
    }

    if (this.placement === 'right') {
      top = hostPos.top + (hostPos.height - tooltipPos.height) / 2;
      left = hostPos.right + this.offset;
    }
    this.renderer.setStyle(this.popover, 'top', `${top + scrollPos}px`);
    this.renderer.setStyle(this.popover, 'left', `${left}px`);
  }

  checkPopoverPosition() {
    const hostPos = this.el.nativeElement.getBoundingClientRect();
    const viewportWidth = window.innerWidth;

    const spaceLeft = hostPos.left;
    const spaceRight = viewportWidth - hostPos.right;

    if (spaceLeft > spaceRight) this.componentRef.instance.rightPopover = false;
    else this.componentRef.instance.rightPopover = true;
  }

  remove() {
    const parent = document.querySelector(this.parentSelector);

    if (parent) {
      const popovers = parent.querySelectorAll('message-popover'); // پیدا کردن همه تگ‌های MessagePopover

      popovers.forEach((popover) => {
        if (popover) parent.removeChild(popover); // حذف هر popover از DOM
      });
    }
  }
}
